export namespace Auth {
  export enum Pages {
    SIGN_UP = 'signup',
    SIGN_IN = 'signin',
  }

  export interface Token {
    token: string,
  }

  export enum TokenPrefix {
    JWT = 'jwt'
  }
}
